/** HH:MM:SS in UTC — used for the clock and alert timestamps (mono). */
export function formatUtcClock(date: Date): string {
  return date.toISOString().slice(11, 19);
}

/** YYYY-MM-DD HH:MM:SS in UTC — alert timestamps (mono). Includes the date so
 *  an alert from any day (e.g. a year-back custom window) is unambiguous. */
export function formatTimestamp(iso: string): string {
  return new Date(iso).toISOString().slice(0, 19).replace('T', ' ');
}
